export const status = [
  {
    id: "1",
    name: "심의서류 준비",
  },
  {
    id: "2",
    name: "접수",
  },
  {
    id: "3",
    name: "심의중",
  },
  {
    id: "4",
    name: "시정승인",
  },
  {
    id: "5",
    name: "보완",
  },
  {
    id: "6",
    name: "반려",
  },
  {
    id: "7",
    name: "보류",
  },
  {
    id: "8",
    name: "승인",
  },
];
